import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { RevisePriceProps } from 'shared/services';

export function useUpdateQuote() {
    const { productService } = useService();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    const mutation = useMutation<string, Error, RevisePriceProps>(request => productService.revisePrice(request), {
        onSuccess: message => {
            enqueueSnackbar(message, { variant: 'success' });
            queryClient.invalidateQueries('products');
        },
    });
    return mutation;
}
